module.exports = __webpack_public_path__ + "static/feather-1-19a846919d64ac8fc8e9862afe7e21ce.png";